var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.stage === 'modal')?_c('LensCreationModal',{on:{"proceed":_vm.proceedToDrawer,"close":function($event){return _vm.$emit('close')}}}):(_vm.stage === 'drawer')?_c('LensCreationDrawer',{on:{"created":function($event){return _vm.$emit('created')},"close":function($event){return _vm.$emit('close')}}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }